import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "size"];
import styled from 'styled-components';
import UITable from 'UIComponents/table/UITable';
import GutterContainer from './GutterContainer';
import { NEXT_COMPONENT_SPACING } from 'developer-docs-shared-components/config/cssConstants';
import { jsx as _jsx } from "react/jsx-runtime";
export const Spacer = styled.div.withConfig({
  displayName: "Table__Spacer",
  componentId: "p404w3-0"
})(["margin-bottom:", "px;"], NEXT_COMPONENT_SPACING);
export const StyledTable = styled(UITable).withConfig({
  displayName: "Table__StyledTable",
  componentId: "p404w3-1"
})(["td *:last-child{margin-bottom:0;}"]);
const Table = _ref => {
  let {
      children,
      size = 'large'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(GutterContainer, {
    size: size,
    children: /*#__PURE__*/_jsx(Spacer, {
      children: /*#__PURE__*/_jsx(StyledTable, Object.assign({}, rest, {
        children: children
      }))
    })
  });
};
export default Table;